
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14.016h6l-.016-6L12 8.022l.008 2.521-7.022-6.985L3.47 2.016 6 2.024 6.006.016 0 0v6.016h2v-2.65l1.582 1.576.694.707.007-.008 6.4 6.375H8v2z"}}),_c('path',{attrs:{"d":"M3.471 12.024l2.187-2.2-1.385-1.388L2 10.722V8.016H0v6L6 14l-.006-1.984-2.523.008zM10.529 2.008l-2.187 2.2 1.385 1.388L12 3.31v2.706h2v-6L8 .032l.006 1.984 2.523-.008z"}})])
          )
        }
      }
    